/* goldn-wide.js: header hide and show with hysteresis, sticky buy column offset, once-only footer entrance.
   Approved by Victor on 14 Oct 2026. Load with defer from layout/theme.liquid. Replaces the theme's sticky-header.js
   (turn off "Enable sticky header" in the header settings so both never run together). */
(() => {
  if (window.__gnWide) return;
  window.__gnWide = true;

  const root = document.documentElement;
  const header = document.querySelector('.section--site-header');
  const announcement = document.querySelector('.section--announcement-bar, [id*="announcement-bar"]');
  const buy = document.querySelector('.g26-buy');
  const desktop = window.matchMedia('(min-width: 990px)');
  const HIDE_AFTER = 80;   // px of continuous downward scroll before the header leaves
  const SHOW_AFTER = 40;   // px of continuous upward scroll before it comes back

  let lastY = window.scrollY;
  let travel = 0;
  let hidden = false;
  let ticking = false;

  const headerHeight = () => (header ? header.getBoundingClientRect().height : 0);
  const annHeight = () => (announcement ? announcement.getBoundingClientRect().height : 0);
  const headerStart = () => annHeight();   // the announcement bar sits above the header
  const setSizes = () => {
    root.style.setProperty('--gn-ann-h', `${Math.round(annHeight())}px`);
    root.style.setProperty('--gn-hdr-h', `${Math.round(headerHeight())}px`);
  };

  function updateBuy() {
    if (!buy || !desktop.matches) return;
    const wanted = (hidden ? 0 : headerHeight()) + 24;
    const fit = window.innerHeight - buy.offsetHeight - 16;   // keeps the bottom on screen when the column is tall
    root.style.setProperty('--gn-buy-top', `${Math.round(Math.min(wanted, fit))}px`);
  }

  function setHidden(next) {
    if (next === hidden) return;
    hidden = next;
    root.classList.toggle('gn-hdr-hidden', hidden);
    root.style.setProperty('--gn-header-shown', hidden ? '0px' : `${Math.round(headerHeight())}px`);
    updateBuy();
  }

  function onScroll() {
    ticking = false;
    const y = Math.max(0, window.scrollY);
    const dy = y - lastY;
    lastY = y;
    root.classList.toggle('gn-hdr-stuck', y > headerStart());

    // Keep the header while a menu, the search or the cart drawer is open, and near the top of the page.
    if (root.classList.contains('goldn-mega-open') || document.querySelector('cart-drawer.active, menu-drawer.active, details[open] > .search-modal')) { travel = 0; setHidden(false); return; }
    if (y <= headerStart() + headerHeight()) { travel = 0; setHidden(false); return; }

    if ((dy > 0 && travel < 0) || (dy < 0 && travel > 0)) travel = 0;   // direction change starts a new count
    travel += dy;
    if (!hidden && travel >= HIDE_AFTER) { setHidden(true); travel = 0; }
    else if (hidden && travel <= -SHOW_AFTER) { setHidden(false); travel = 0; }
  }

  if (header) {
    window.addEventListener('scroll', () => {
      if (!ticking) { ticking = true; window.requestAnimationFrame(onScroll); }
    }, { passive: true });
    header.addEventListener('focusin', () => setHidden(false));   // keyboard users always get the header back
    setSizes();
    root.style.setProperty('--gn-header-shown', `${Math.round(headerHeight())}px`);
    // The cart drawer opens after Add to cart while the header may be hidden: bring the header back first.
    const drawer = document.querySelector('cart-drawer');
    if (drawer && 'MutationObserver' in window) {
      new MutationObserver(() => { if (drawer.classList.contains('active')) setHidden(false); })
        .observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
  }
  updateBuy();
  window.addEventListener('resize', () => { setSizes(); updateBuy(); }, { passive: true });
  if (buy && 'ResizeObserver' in window) new ResizeObserver(updateBuy).observe(buy);

  // PDP gallery on desktop: first 4 photos, then a button for the rest. Phones keep the slider.
  const gallery = document.querySelector('.g26-gallery');
  const slides = gallery ? gallery.querySelectorAll('.g26-gallery__slide') : [];
  if (gallery && slides.length > 4) {
    const stage = gallery.querySelector('.g26-gallery__stage') || gallery;
    const more = document.createElement('button');
    more.type = 'button';
    more.className = 'gn-gal-all';
    more.setAttribute('aria-expanded', 'false');
    more.textContent = `Show all ${slides.length} photos`;
    const sync = () => { const on = desktop.matches; gallery.classList.toggle('gn-gal-more', on && more.getAttribute('aria-expanded') === 'false'); more.hidden = !on || more.getAttribute('aria-expanded') === 'true'; };
    more.addEventListener('click', () => { more.setAttribute('aria-expanded', 'true'); sync(); updateBuy(); });
    stage.after(more);
    desktop.addEventListener('change', sync);
    sync();
  }

  // Footer: plays once per page view when it first comes into view.
  const footer = document.querySelector('.goldn-footer');
  if (footer && 'IntersectionObserver' in window) {
    footer.classList.add('gn-foot-pre');
    const io = new IntersectionObserver((entries) => {
      if (!entries.some((e) => e.isIntersecting)) return;
      footer.classList.add('gn-foot-in');
      io.disconnect();
    }, { threshold: 0.15 });
    io.observe(footer);
  }
})();
